import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SingleStepSportEventParticipantsFragmentDoc } from './SingleStepSportEventParticipants.fragment';
import { MultiStepSportEventParticipantsFragmentDoc } from './MultiStepSportEventParticipants.fragment';
import { SportEventOffersV2FragmentDoc } from './SportEventOffersV2.fragment';
export type SportCompetitionPageFragment = {
	__typename?: 'SportCompetitionV2';
	id: string;
	objectType: Types.ObjectType;
	objectId: number;
	sport: Types.SportType;
	content: { __typename?: 'SportCompetitionContentV2'; name: string; fullPath: string; iconUrl?: string | null };
	activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
	sportEventsV2: {
		__typename?: 'SportEventsConnectionV2';
		pageInfo: {
			__typename?: 'PageInfo';
			startCursor: string;
			endCursor: string;
			hasPreviousPage: boolean;
			hasNextPage: boolean;
		};
		edges?: Array<{
			__typename?: 'SportEventsEdgeV2';
			node:
				| {
						__typename?: 'MultiStepSportEvent';
						id: string;
						objectId: number;
						sport: Types.SportType;
						offerCount: number;
						competition?: {
							__typename?: 'SportCompetitionV2';
							id: string;
							objectId: number;
							activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
						} | null;
						content: {
							__typename?: 'MultiStepSportEventContent';
							startAt: any;
							endAt?: any | null;
							status: Types.SportEventStatus;
							fullPath?: string | null;
							venue?: { __typename?: 'SportVenue'; name: string; venueID: number } | null;
							competitionStage: {
								__typename?: 'SportCompetitionStageV2';
								name: Types.SportCompetitionStageName;
								number?: number | null;
							};
						};
						parent?: {
							__typename?: 'MultiStepSportEvent';
							id: string;
							content: {
								__typename?: 'MultiStepSportEventContent';
								name: string;
								fullPath?: string | null;
								startAt: any;
								status: Types.SportEventStatus;
							};
						} | null;
						watchNowOffer?: {
							__typename?: 'SportOffer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							audioLanguage?: string | null;
							standardWebURL?: string | null;
							sportObjectType: Types.SportObjectType;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								technicalName: string;
								clearName: string;
								monetizationTypes: Array<Types.MonetizationType>;
							};
						} | null;
						offers: Array<{
							__typename?: 'SportOffer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							audioLanguage?: string | null;
							standardWebURL?: string | null;
							sportObjectType: Types.SportObjectType;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								technicalName: string;
								clearName: string;
								monetizationTypes: Array<Types.MonetizationType>;
							};
						}>;
				  }
				| {
						__typename?: 'SingleStepSportEvent';
						id: string;
						objectId: number;
						sport: Types.SportType;
						offerCount: number;
						competition?: {
							__typename?: 'SportCompetitionV2';
							id: string;
							objectId: number;
							activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
						} | null;
						content: {
							__typename?: 'SingleStepSportEventContent';
							startAt: any;
							endAt?: any | null;
							status: Types.SportEventStatus;
							fullPath?: string | null;
							venue?: { __typename?: 'SportVenue'; name: string; venueID: number } | null;
							competitionStage: {
								__typename?: 'SportCompetitionStageV2';
								name: Types.SportCompetitionStageName;
								number?: number | null;
							};
						};
						competitors: {
							__typename?: 'SingleStepSportCompetitorsV2';
							homeTeam: {
								__typename?: 'SingleStepSportCompetitorV2';
								score?: number | null;
								winner: boolean;
								competitors: Array<{
									__typename?: 'SportCompetitorV2';
									id: string;
									objectId: number;
									content: {
										__typename?: 'SportCompetitorContentV2';
										name: string;
										iconUrl?: string | null;
										fullPath?: string | null;
									};
								}>;
							};
							awayTeam: {
								__typename?: 'SingleStepSportCompetitorV2';
								score?: number | null;
								winner: boolean;
								competitors: Array<{
									__typename?: 'SportCompetitorV2';
									id: string;
									objectId: number;
									content: {
										__typename?: 'SportCompetitorContentV2';
										name: string;
										iconUrl?: string | null;
										fullPath?: string | null;
									};
								}>;
							};
						};
						watchNowOffer?: {
							__typename?: 'SportOffer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							audioLanguage?: string | null;
							standardWebURL?: string | null;
							sportObjectType: Types.SportObjectType;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								technicalName: string;
								clearName: string;
								monetizationTypes: Array<Types.MonetizationType>;
							};
						} | null;
						offers: Array<{
							__typename?: 'SportOffer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							audioLanguage?: string | null;
							standardWebURL?: string | null;
							sportObjectType: Types.SportObjectType;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								technicalName: string;
								clearName: string;
								monetizationTypes: Array<Types.MonetizationType>;
							};
						}>;
				  };
		}> | null;
	};
};

export const SportCompetitionPageFragmentDoc = gql`
	fragment SportCompetitionPage on SportCompetitionV2 {
		id
		objectType
		objectId
		sport
		content(country: $country, language: $language) {
			name
			fullPath
			iconUrl
		}
		activeSeason(country: $country, language: $language) {
			name
			seasonID
		}
		sportEventsV2(
			after: $after
			country: $country
			filter: $filter
			first: $first
			timezoneOffset: $timezoneOffset
			sortOrder: $sortOrder
		) {
			pageInfo {
				startCursor
				endCursor
				hasPreviousPage
				hasNextPage
			}
			edges {
				node {
					id
					objectId
					sport
					competition {
						id
						objectId
						activeSeason(country: $country, language: $language) {
							name
							seasonID
						}
					}
					content(country: $country, language: $language) {
						startAt
						endAt
						status
						fullPath
						venue {
							name
							venueID
						}
						competitionStage {
							name
							number
						}
					}
					...SingleStepSportEventParticipants
					...MultiStepSportEventParticipants
					...SportEventOffersV2
				}
			}
		}
	}
	${SingleStepSportEventParticipantsFragmentDoc}
	${MultiStepSportEventParticipantsFragmentDoc}
	${SportEventOffersV2FragmentDoc}
`;
